var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nuxt-img',{staticClass:"rounded-md max-w-full",class:_vm.widgetClasses,attrs:{"src":_vm.value.config.image || _vm.placeholder,"alt":_vm.value.config.alt,"format":"webp","quality":"80","placeholder":"","loading":"lazy"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }